/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Rule_SetsInputs */

const en_tables_rule_sets_rule_sets = /** @type {(inputs: Tables_Rule_Sets_Rule_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Rule Sets`)
};

const de_tables_rule_sets_rule_sets = /** @type {(inputs: Tables_Rule_Sets_Rule_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Sets`)
};

/**
* | output |
* | --- |
* | "Sets Rule Sets" |
*
* @param {Tables_Rule_Sets_Rule_SetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_rule_sets = /** @type {((inputs?: Tables_Rule_Sets_Rule_SetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Rule_SetsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_rule_sets(inputs)
	return de_tables_rule_sets_rule_sets(inputs)
});